import React from "react";
import SprTovDeny from "./spr-tov-deny";
import SprTovMain from "./spr-tov-main";
import SprTovParams from "./spr-tov-params";
import SprTovRests from "./spr-tov-rests";

export const TOV_TAB_KEYS = {
  MAIN: "main",
  PARAMS: "params",
  DENY: "deny",
  REST: "rest"
};

export const TOV_TAB_ITEMS = [
  { key: TOV_TAB_KEYS.MAIN, label: "Основная" },
  { key: TOV_TAB_KEYS.PARAMS, label: "Параметры" },
  { key: TOV_TAB_KEYS.DENY, label: "Совместимость" },
  { key: TOV_TAB_KEYS.REST, label: "Остатки" }
];

/**
 * Карточка группы / услуги: контент активной вкладки.
 */
const SprTovCard = ({
  idTov,
  isNew = false,
  isGroupNew = false,
  idUpper,
  open,
  activeTab,
  parentOptions,
  onSaved,
  onCancel
}) => {
  const mainProps = {
    idTov,
    isNew,
    isGroupNew,
    idUpper,
    open,
    parentOptions,
    onSaved,
    onCancel
  };

  if (isNew || isGroupNew) {
    return <SprTovMain {...mainProps} />;
  }

  switch (activeTab) {
    case TOV_TAB_KEYS.PARAMS:
      return <SprTovParams idTov={idTov} />;
    case TOV_TAB_KEYS.DENY:
      return <SprTovDeny idTov={idTov} />;
    case TOV_TAB_KEYS.REST:
      return <SprTovRests idTov={idTov} />;
    case TOV_TAB_KEYS.MAIN:
    default:
      return <SprTovMain {...mainProps} />;
  }
};

export default SprTovCard;
